var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,25l-0.6,0.9c2.5,0.8,4.1,2.2,4.1,3.7c0,2.4-4.3,4.5-9.5,4.5v0.1V34c-5.2,0-9.5-2.1-9.5-4.5c0-1.5,1.6-2.9,4.1-3.7 L12,24.9c-2.8,1-4.5,2.6-4.5,4.6c0,3.1,4.6,5.5,10.5,5.5s10.5-2.4,10.5-5.5C28.5,27.6,26.7,25.9,24,25z M18,17c3,0,5.5-2.5,5.5-5.5 C23.5,8.5,21,6,18,6c-3,0-5.5,2.5-5.5,5.5C12.5,14.5,15,17,18,17z M18,7c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5 c-2.5,0-4.5-2-4.5-4.5C13.5,9,15.5,7,18,7C18,7,18,7,18,7z M18,30.4l8.9-13.6c1-1.6,1.5-3.4,1.6-5.3C28.5,5.7,23.8,1,18,1 S7.5,5.7,7.5,11.5c0.1,1.9,0.6,3.7,1.6,5.3L18,30.4z M18,2c5.2,0,9.5,4.3,9.5,9.5c-0.1,1.7-0.6,3.3-1.4,4.7L18,28.6L9.9,16.2 c-0.9-1.4-1.4-3.1-1.4-4.7C8.5,6.3,12.8,2,18,2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.80e17c9581bda96a25eb063f23cef6cc.svg";
export { ForwardRef as ReactComponent };